import styled, { css } from 'styled-components';

export const Container = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  flex: 1;
  align-items: center;
  gap: ${({ theme }) => theme.spacing[7]}px;
  padding: ${({ theme }) => `${theme.spacing[5]}px ${theme.spacing[4]}px`};
  margin-top: ${({ theme }) => theme.spacing[4]}px;

  ${({ theme }) => {
    return css`
      font-size: ${theme.typography.font.size[3]}px;
      font-family: var(--font-${theme.typography.font.family.text});
      font-weight: ${theme.typography.font.weight.medium};
      line-height: ${theme.typography.font.line_height[4]}px;
      color: ${theme.colors.neutral.neutral_alpha[12]};
    `;
  }};
`;

export const ContainerTop = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;
  gap: ${({ theme }) => theme.spacing[6]}px;
`;

export const ContainerInfos = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  gap: ${({ theme }) => theme.spacing[4]}px;
  justify-content: space-around;
  width: 100%;
  flex: 1;
`;

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const BackgroundWrapper = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  top: 0;
  left: 0;
  width: 100%;
  height: 250px;
  z-index: -1;
  background-color: black;
`;

export const Grandiente = styled.div`
  z-index: 1;
  position: absolute;
  height: 100%;
  width: 100%;
  background: linear-gradient(
    to bottom,
    rgba(17, 17, 17, 0.1),
    rgba(17, 17, 17, 1)
  );
`;

export const BlurredBackground = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  img {
    filter: blur(21.25px) brightness(0.75);
  }
`;

export const ContainerInput = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: ${({ theme }) => theme.spacing[4]}px;
  border-radius: ${({ theme }) => theme.radius[2]}px;
  background-color: ${({ theme }) => theme.colors.neutral.neutral[2]};
  margin-top: ${({ theme }) => theme.spacing[4]}px;
  gap: ${({ theme }) => theme.spacing[5]}px;
`;

export const TextInput = styled.textarea`
  min-height: 44px;
  width: 100%;
  resize: vertical;
  height: 100px;
  resize: none;

  ${({ theme }) => {
    return css`
      font-size: ${theme.typography.font.size[3]}px;
      font-family: var(--font-${theme.typography.font.family.text});
      font-weight: ${theme.typography.font.weight[3]};
      line-height: ${theme.typography.font.line_height[3]}px;
      color: ${theme.colors.neutral.neutral[12]};
    `;
  }}
`;
